'use client';

import posthog from 'posthog-js';
import { useEffect } from 'react';

import { APPLICATION_DISTINCT_ID_PREFIX } from '@/lib/analytics/constants';
import { hasAnalyticsOptOutFromDocument } from '@/lib/analytics/opt-out';
import { ANALYTICS_CONSENT_CHANGE_EVENT } from '@/lib/analytics/usercentrics';

export default function IdentifyApplication({
  applicationDistinctId,
  hasSecondTenant,
}: {
  applicationDistinctId: string;
  hasSecondTenant: boolean;
}) {
  useEffect(() => {
    const identifyApplication = () => {
      if (hasAnalyticsOptOutFromDocument() || !posthog.has_opted_in_capturing()) {
        return;
      }

      const currentDistinctId = posthog.get_distinct_id();

      if (currentDistinctId === applicationDistinctId) {
        return;
      }

      if (currentDistinctId.startsWith(APPLICATION_DISTINCT_ID_PREFIX)) {
        posthog.reset();
        posthog.opt_in_capturing();
      }

      posthog.identify(applicationDistinctId, {
        flow: 'application',
        has_second_tenant: hasSecondTenant,
      });
    };

    identifyApplication();
    window.addEventListener(ANALYTICS_CONSENT_CHANGE_EVENT, identifyApplication);

    return () => {
      window.removeEventListener(ANALYTICS_CONSENT_CHANGE_EVENT, identifyApplication);
    };
  }, [applicationDistinctId, hasSecondTenant]);

  return null;
}
